import { selectHasPermissions } from '@redux/Roles/roles.selectors';
import { useAppSelector } from '@redux/store';
import { StudioRoutes } from './RouteConstants';

/**
 * @returns string - The home route for the studio based on the user's permissions
 */
export const useGetStudioHomeRoute = (): string => {
  const hasPermission = useAppSelector((state) =>
    selectHasPermissions(state, ['models', 'model', 'r'])
  );

  if (hasPermission) {
    return `/${StudioRoutes.base}/${StudioRoutes.model.base}`;
  }

  return `/${StudioRoutes.base}/${StudioRoutes.api.base}`;
};
